
/**
 * Creates and returns string with string "für Objekt" between element content and index
 * @param elementContent: string
 * @param index: number
 * @returns: string - element content with "für Objekt" and index
 * <br>e.g. getAriaLabelForObjektWithIndex('PLZ', 1) will return string "PLZ für Objekt 1"
 */
export function createAriaLabelForObjektWithIndex(elementContent: string, index: number): string {
  return `${elementContent} für Objekt ${index}`;
}

/**
 * Creates and returns string "description für Objekt index: elementContent"
 * @param description: string
 * @param elementContent: string
 * @param index: number
 * @returns string
 * <br>e.g createAriaLabelForObjektWithIndexAndDescription('Radio button', 'bebaut', 1) will return
 * "Radio button für Objekt 1: bebaut"
 */
export function createAriaLabelForObjektWithIndexAndDescription(
  description: string,
  elementContent: string,
  index: number,
): string {
  return `${createAriaLabelForObjektWithIndex(description, index)}: ${elementContent}`;
}

/**
 * Creates and returns string "description für Objekt index: elementContent: errorText"
 * @param shouldShowError: boolean
 * @param description: string
 * @param elementContent: string
 * @param index: number
 * @param errorText: string
 * @returns string
 * <br>e.g 1:  createAriaLabelForObjektWithIndexAndDescriptionAndError(false, 'Radio button', 'bebaut', 1, 'Field is required') returns 'Radio button für Objekt 1: bebaut'
 * <br>e.g 2:  createAriaLabelForObjektWithIndexAndDescriptionAndError(true, 'Radio button', 'bebaut', 1, 'Field is required') returns 'Radio button für Objekt 1: bebaut: Field is required'
 */
export function createAriaLabelForObjektWithIndexAndDescriptionAndError(
  shouldShowError: boolean,
  description: string,
  elementContent: string,
  index: number,
  errorText: string,
): string {
  description = createAriaLabelForObjektWithIndexAndDescription(description, elementContent, index);
  if (shouldShowError) {
    description = `${description}: ${errorText}`;
  }
  return description;
}
